export const AUTH_KEY = 'session';
export const LOCAL_SETTINGS_KEY = 'appSettings';
export const COUNTRY_CONTEXT_KEY = 'currentCountryContext';
export const CURRENT_INTERVIEW_DATE_KEY = 'currentInterviewDate';
export const CURRENT_TIMEZONE_KEY = 'currentTimezone';
export const THEME_CONFIG_KEY = 'themeConfig:v2';
export const LAST_THEME_FETCH_DATE_KEY = 'lastThemeFetchDate:v2';
export const LAST_VISITED_ROUTE_KEY = 'lastVisitedRoute';
export const LANGUAGE_KEY = 'currentLanguage';
